import theme from "./theme";

// to create button styles
const baseButtonStyles = {
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.fontSize.sm,
  fontWeight: theme.typography.fontWeight.medium,
  borderRadius: theme.borderRadius.md,
  padding: "4px 8px",
  cursor: "pointer",
  transition: "background-color 0.2s ease, color 0.2s ease",
  textTransform: "none",
  "&.Mui-disabled": {
    cursor: "not-allowed",
    pointerEvents: "none",
    fontWeight: theme.typography.fontWeight.light,
  },
};

// Responsive font size (optional - if using CSS-in-JS solution like styled-components or emotion)
const responsiveFont = {
  "@media (max-width: 600px)": {
    fontSize: theme.typography.fontSize.sm,
    padding: "8px 14px",
  },
};

// used as primary action button (that contains text)
export const primaryButtonStyles = {
  ...baseButtonStyles,
  ...responsiveFont,
  color: theme.textColors.dark.primary,
  backgroundColor: theme.main.primaryBlue,
  ":hover": {
    backgroundColor: theme.utils.getHoverColor(theme.main.primaryBlue, "dark"),
  },
  "&.Mui-disabled": {
    backgroundColor: theme.utils.getDisabledColor(theme.main.primaryBlue),
    color: theme.textColors.dark.disabled,
    cursor: "not-allowed",
    pointerEvents: "none",
    fontWeight: theme.typography.fontWeight.light,
  },
};

// used as secondary action button with primary button present(that contains text)
export const secondaryButtonStyles = {
  ...baseButtonStyles,
  ...responsiveFont,
  color: theme.textColors.dark.primary,
  backgroundColor: theme.main.secondaryBlue,
  ":hover": {
    backgroundColor: theme.utils.getHoverColor(
      theme.main.secondaryBlue,
      "dark"
    ),
  },
  "&.Mui-disabled": {
    color: theme.textColors.dark.secondary,
    backgroundColor: theme.utils.getDisabledColor(theme.main.secondaryBlue),
  },
};

// used as delete orimary action button (that contains text)
export const deleteButtonStyles = {
  ...baseButtonStyles,
  ...responsiveFont,
  color: theme.textColors.dark.primary,
  backgroundColor: theme.state.error.primary,
  ":hover": {
    backgroundColor: theme.state.error.secondary,
  },
  "&.Mui-disabled": {
    color: theme.textColors.dark.disabled,
    backgroundColor: theme.state.error.secondary,
  },
};

// used in table components as tertiary button
export const tertiaryButtonStyles = {
  ...baseButtonStyles,
  backgroundColor: theme.backgroundColors.dark.tableButton.primary,
  ...responsiveFont,
  color: theme.textColors.dark.primary,
  "&:hover": {
    backgroundColor: theme.utils.getHoverColor(
      theme.backgroundColors.dark.tableButton.primary
    ),
  },
  "&.Mui-disabled": {
    backgroundColor: theme.utils.getDisabledColor(
      theme.backgroundColors.dark.tableButton.primary
    ),
    color: theme.textColors.dark.secondary,
  },
};

export const iconButtonBase = {
  padding: "4px",
  borderRadius: theme.borderRadius.sm,
  backgroundColor: "transparent",
  transition: "background-color 0.2s ease, color 0.2s ease",
  cursor: "pointer",
  fontSize: theme.typography.fontSize.xs,
};

// Primary action icon button for tables
export const iconButtonActive = {
  ...iconButtonBase,
  backgroundColor: theme.backgroundColors.dark.tableButton.primary,
  color: theme.textColors.dark.primary,
  width: "36px",
  height: "36px",
  borderRadius: "8px",
  "&:hover": {
    backgroundColor: theme.utils.getHoverColor(
      theme.backgroundColors.dark.tableButton.primary
    ),
    color: theme.textColors.dark.secondary,
  },
  "&.Mui-disabled": {
    color: theme.textColors.dark.disabled,
    cursor: "not-allowed",
    pointerEvents: "none",
  },
};

// primary icon button style
export const iconButtonStyles = {
  ...iconButtonBase,
  color: theme.textColors.dark.primary,
  "&:hover": {
    color: theme.textColors.dark.secondary,
  },
  "&.Mui-disabled": {
    color: theme.textColors.dark.disabled,
  },
};

// delete primary button
export const deleteIconStyles = {
  ...iconButtonBase,
  color: theme.state.error.primary,
  "&:hover": {
    backgroundColor: theme.utils.getHoverColor(
      theme.state.error.primary,
      "dark"
    ),
    color: theme.textColors.dark.primary,
    fontSize: theme.typography.fontSize.xxs,
  },
};

// primary text button
export const textButtonStyles = {
  ...baseButtonStyles,
  padding: "4px 8px",
  ...responsiveFont,
  backgroundColor: "transparent",
  color: theme.textColors.dark.primary,
  ":hover": {
    color: theme.main.primaryBlue,
    backgroundColor: theme.utils.getHoverColor(
      theme.backgroundColors.dark.blackVariants.primary,
      "dark"
    ),
  },
  "&.Mui-disabled": {
    color: theme.textColors.dark.disabled,
    cursor: "not-allowed",
    pointerEvents: "none",
  },
};
